// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {Avatar, makeStyles} from '@material-ui/core';
import type {AvatarProps} from '@material-ui/core';

import type {Node} from 'react';
import type {Theme} from '@material-ui/core';
type Props = {
  children?: Node,
  size?: 'small' | 'medium' | 'large',
  className?: string,
} & AvatarProps;

const useStyles = makeStyles((theme: Theme) => ({
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    minWidth: theme.spacing(4),
    minHeight: theme.spacing(4),
  },
  medium: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    minWidth: theme.spacing(6),
    minHeight: theme.spacing(6),
  },
  large: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    minWidth: theme.spacing(8),
    minHeight: theme.spacing(8),
  },
}));

export default function CustomAvatar(props: Props) {
  const {children, size = 'small', className, ...otherProps} = props;
  const classes = useStyles();

  const innerClassName = {
    small: classes.small,
    medium: classes.medium,
    large: classes.large,
  }[size];

  return (
    <Avatar className={`${innerClassName} ${className || ''}`} {...otherProps}>
      {children}
    </Avatar>
  );
}

CustomAvatar.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};
